app
    .controller('ShareLinkCtrl', function ($http) {

        this.cancel = () => {
            this.dismiss();
        };

        this.copyLink = () => {
            // this.dismiss();
            var el = document.createElement('textarea');
            el.value = this.resolve.link;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        };

        this.$onInit = () => {
        };
    })
    .component('shareLink', {
        template: `
        <div style="width: 100%; min-width: 32vw;">
            <div class="modal-header header p-1 mb-2" style="border-bottom: 1px solid #1D1D1B;">
                <h1 style="font-size: 24px; font-family: 'goboldregular', Impact, sans-serif;margin: 10px auto; text-align: center;">
                    <span class="ml-2">{{ 'modal.shareLink.shareALink' | translate }}</span>
                </h1>
                <button class="btn btn-close" ng-click="$ctrl.cancel()">
                    <chat-icon type="cross" width="15" />
                </button>
            </div>
            <div class="body mt-4 mb-4">
                <div style="height: 20vh; display: flex; justify-content: center; align-items: center;">
                    <div class="form-group row mb-2 mt-4" style="width:95%;">
                        <div class="col-12">
                            <input type="text" value="{{$ctrl.resolve.link}}" class="form-control" style="padding-left: 40px;" readonly>
                            <span class="help-block" style="font-size:12px;"><i>{{ 'modal.shareLink.details' | translate }}</i></span>
                            <div class="sg-link-input-unit-placeholder"><chat-icon type="link" width="26" height="13"></chat-icon></div>
                        </div>
                        <div class="col-12 text-right my-3">
                            <button class="btn btn-reject font-go-bold" ng-click="$ctrl.cancel()">
                                {{ 'modal.btn.cancel' | translate }}
                            </button>
                            <button class="btn btn-green font-go-bold" ng-click="$ctrl.copyLink()">
                                {{ 'modal.btn.copyLink' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `,
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: 'ShareLinkCtrl'
    });
